import { createClient, type SupabaseClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL?.trim()
const supabaseKey = (
  import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ||
  import.meta.env.VITE_SUPABASE_ANON_KEY
)?.trim()

let browserClient: SupabaseClient | null = null

export const hasSupabaseBrowserConfig = (): boolean => Boolean(supabaseUrl && supabaseKey)

export const getSupabaseBrowserClient = (): SupabaseClient => {
  if (!supabaseUrl || !supabaseKey) {
    throw new Error('Supabase browser environment variables are not configured.')
  }

  if (!browserClient) {
    browserClient = createClient(supabaseUrl, supabaseKey, {
      auth: {
        autoRefreshToken: true,
        persistSession: true,
      },
    })
  }

  return browserClient
}